<template>
    <div class="port-list-table">
        <el-table
            :data="getPortList.itens"
            :empty-text="translate('messages.view.no_data')"
            highlight-current-row
        >
            <el-table-column
                width="150px"
                prop="codigoLyra"
                :label="translate('table.lyra_id')"
                label-class-name="factory-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="numeroRegistro"
                :label="translate('table.industrial_registration_number')"
                label-class-name="port-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ validateText(scope.row.numeroRegistro) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="150px"
                prop="numeroDocumento"
                :label="translate('table.ruc')"
                label-class-name="port-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="razaoSocial"
                :label="translate('table.legal_name')"
                label-class-name="port-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="localidadeNivel1"
                :label="translate('table.location')"
                label-class-name="port-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ scope.row.localidadeNivel2 + " - " + scope.row.localidadeNivel1}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="100px"
                :label="translate('table.product_codes_simplified.soja') + ' (t)'"
                label-class-name="port-list-table_label"
                align="center"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ formatTonValue(volumeExportacaoPorCodigo(scope.row, 'SOJA')) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="100px"
                :label="translate('table.product_codes_simplified.farinha') + ' (t)'"
                label-class-name="port-list-table_label"
                align="center"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ formatTonValue(volumeExportacaoPorCodigo(scope.row, 'FARINHA')) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="100px"
                :label="translate('table.product_codes_simplified.oleo') + ' (t)'"
                label-class-name="port-list-table_label"
                align="center"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ formatTonValue(volumeExportacaoPorCodigo(scope.row, 'OLEO')) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="100px"
                :label="translate('table.product_codes_simplified.casca') + ' (t)'"
                label-class-name="port-list-table_label"
                align="center"
            >
                <template v-slot:default="scope">
                    <div class="port-list_text">
                        {{ formatTonValue(volumeExportacaoPorCodigo(scope.row, 'CASCA')) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="120px"
                :label="translate('table.actions')"
                align="center"
                label-class-name="port-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-dropdown
                        class="action-button"
                        trigger="click"
                        @click="scope"
                    >
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical" />
                        </span>
                        <el-dropdown-menu v-slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-view"
                                @click.native="handleView(scope.row)"
                            >
                                {{ translate('messages.view_port') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-map-location"
                                @click.native="openViewTerritoriesModal(scope.row)"
                            >
                                {{ translate('messages.view.view_territories') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="port-list-table__pagination">
            <div class="total">
                <span
                    >{{ getPortList.totalItens }}
                    {{
                        translate('messages.view.results')
                    }}</span
                >
                <div style="margin: 0 20px"></div>
                <span
                    >{{
                        translate('messages.view.views_by_page')
                    }}:</span
                >
                <el-pagination
                    @size-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="sizes"
                    :total="getPortList.totalItens"
                />
            </div>
            <div class="prev_next">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="prev, pager, next, jumper"
                    :total="getPortList.totalItens"
                />
            </div>
        </div>
        <view-territories-modal
            v-if="showViewTerritoriesModal"
            :show="showViewTerritoriesModal"
            :factory="selectedPort"
            @close="showViewTerritoriesModal = false"
        />
    </div>
</template>

<script>
import ViewTerritoriesModal from '@/modules/warehouse/views/components/ViewTerritoriesModal.vue';

import { mapActions, mapState, mapGetters } from 'vuex';
import { MainPageTabs } from '@/modules/warehouse/constants/MainPageTabsEnum';
import formatters from '@/utils/formatters';

export default {
    name: 'factoryDefault',
    components: {
        ViewTerritoriesModal
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            page: 1,
            size: 10,
            totalElements: 0,
            showViewTerritoriesModal: false,
            selectedPort: null,
            tabName: MainPageTabs.PORTS_TAB
        };
    },
    computed: {
        ...mapState('warehouseModule', ['selectedTab', 'tableLoadControl', 'portFilter', 'searchText']),
        ...mapGetters('warehouseModule', ['getPortList']),
        filterHandler() {
            return [
                this.portFilter.page,
                this.portFilter.size,
                this.searchText
            ];
        }
    },
    created() {
        this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {portList: false});
    },
    mounted() {
        const newFilter = {
            ...this.portFilter,
            page: this.page,
            size: this.size
        };
        this.setPortFilter(newFilter);
    },
    watch: {
        selectedTab: {
            handler(newVal) {
                if (this.selectedTab === this.tabName && !this.tableLoadControl.portList) {
                    this.getPorts();
                }
            }
        },
        filterHandler() {
            if (this.selectedTab === this.tabName && !this.tableLoadControl.portList) {
                this.getPorts();
            }
        }
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchPorts']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = 1;
            this.size = size;
            const newFilter = {
                ...this.portFilter,
                page: this.page,
                size: size
            };
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {portList: false});
            this.setPortFilter(newFilter);
        },
        handleCurrentChange(page) {
            this.page = page;
            const newFilter = {
                ...this.portFilter,
                page: page,
                size: this.size
            };
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {portList: false});
            this.setPortFilter(newFilter);
        },
        handleView(selected) {
            this.$router.push({
                name: 'VisualizarPorto',
                params: {
                    warehouseId: selected.id,
                    viewPendingOperations: 'transacoes-porto',
                    type: 'PORT'
                }
            });
        },
        openViewTerritoriesModal(row) {
            this.showViewTerritoriesModal = true;
            this.selectedPort = row;
        },
        validateText(text) {
            if (!text || text === '') return '-';
            return text;
        },
        getPorts() {
            this.fetchPorts();
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {portList: true});
        },
        setPortFilter(newFilter) {
            this.$store.commit('warehouseModule/SET_PORT_FILTER', newFilter);
        },
        volumeExportacaoPorCodigo(row, codigo) {
            const produtos = row?.produtosVolumeParaExportacao;
            if (!produtos || produtos.length === 0) return null;
            const produto = produtos.find(p => p.codigo === codigo);
            return produto?.volumeTon ?? null;
        },
        formatTonValue(value) {
            if (value !== 0 && (!value || value === '')) return '-';
            return this.formatNumberToLocale(value);
        },
        formatNumberToLocale(value) {
            return formatters.minFormatNumber(value, 3, this.$i18n.locale);
        }
    }
};
</script>

<style scoped lang="scss">
.port-list-table {
    margin-top: -8px;
    .el-table {
        border-radius: 5px;
        height: calc(100% - 60px) !important;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }
    .port-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin: 20px 12px 0;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
.level1-label {
    font-size: 12px;
    color: #7c7c7c !important;
}
::v-deep .port-list-table_label {
    word-break: keep-all !important;
}
.port-list_text {
    word-break: keep-all !important;
}
</style>
